<template>
  <div>
    <v-list class="pa-1">
      <v-list-tile avatar>
        <v-list-tile-content style="width: 60%;">
          <v-list-tile-title
            class="text-xs-center"
            style="font-size: 1.3em"
            >Pix Recebidos</v-list-tile-title
          >
        </v-list-tile-content>
        <v-list-tile-content style="width: 10%;" v-if="meioSelecionado && meioSelecionado.toLowerCase() === 'pagpixbank'">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              lazy
              transition="slide-y-transition"
              offset-y
              full-width
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-btn flat small v-on="on">
                <span class="secondary--text font-weight-medium" style="font-size: 1.2em;">{{date}}</span>
              </v-btn>
            </template>
            <v-date-picker v-model="new_date" no-title scrollable color="primary" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-layout justify-center class="mb-2">
      <v-select
        :items="meiosPagamento"
        item-value="forma_pagamento.descricao"
        item-text="forma_pagamento.descricao"
        hide-details
        solo
        v-model="meioSelecionado"
      ></v-select>
    </v-layout>
    <v-flex xs12 v-if="meioSelecionado && meioSelecionado.toLowerCase() === 'efipix' && cobrancas.length > 0">
      <v-list three-line class="pt-0">
        <template v-for="(cobranca, index) in cobrancas">
          <v-divider v-if="index > 0" :key="cobranca.txid" inset></v-divider>
          <v-menu
            offset-x
            :key="index"
            left
            transition="slide-x-reverse-transition"
          >
            <template v-slot:activator="{ on }">
              <v-list-tile
                class="grey lighten-3"
                :style="{ border: 'solid 2px red' }"
                avatar
                v-on="on"
              >
                <v-list-tile-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-icon color="green darken-2">local_atm</v-icon>
                      </span>
                    </template>
                    <span>/Pix recebidos</span>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-content
                  style="height: 110px; font-size: 11pt; font-weight: bold"
                >
                  <v-list-tile-title>
                    Pagamento via pix
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    style="width: 95%"
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Valor:
                    {{ cobranca.valor | currency({ fractionCount: 2 }) }}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    style="width: 95%"
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Data de utilização:
                    {{
                      dataAtualFormatada(cobranca.calendario)
                    }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-menu>
        </template>
      </v-list>
      <div class="text-xs-center pa-2">
        <v-pagination v-model="paginationCash.page" :length="pagesCash" circle />
      </div>
    </v-flex>
    <v-flex xs12 v-else-if="meioSelecionado && meioSelecionado.toLowerCase() === 'pagpixbank' && transacoesPagPix.length > 0">
      <v-list three-line class="pt-0">
        <template v-for="(transacaoPPB, index) in transacoesPagPix">
          <!-- transacaoPPB = Transação PagPixBank -->
          <v-divider v-if="index > 0" :key="`${index}divider`" inset></v-divider>
          <v-menu
            offset-x
            :key="`${index}menu`"
            left
            transition="slide-x-reverse-transition"
          >

          <template v-slot:activator="{ on }">
              <v-list-tile
                class="grey lighten-3"
                style="border: solid 2px red"
                avatar
                v-on="on"
              >
                <v-list-tile-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-icon color="green darken-2">local_atm</v-icon>
                      </span>
                    </template>
                    <span>/Pix recebidos</span>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    Pagamento via pix
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Valor:
                    {{ transacaoPPB.valor | currency({ fractionCount: 2 }) }}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Data de utilização:
                    {{
                      dataAtualFormatada(transacaoPPB.calendario)
                    }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Status:
                    {{ transacaoPPB.status }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile
              class="grey lighten-3"
              avatar
              @click="transacaoSelecionada = transacaoPPB, visualizar = true"
            >
            <v-list-tile-avatar>
              <v-icon color="primary">visibility</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title
                class="grey--text text--darken-3 caption font-weight-medium"
              >
                VISUALIZAR
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          </v-menu>
        </template>
      </v-list>
    </v-flex>
    <v-dialog
      lazy
      width="500"
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="dialogEditarCupom"
    >
      <editar-cupom
        @fechar="dialogEditarCupom = false"
        :voucherEmpresa="voucherEmpresa"
      ></editar-cupom>
    </v-dialog>
    <v-dialog
      v-model="visualizar"
      lazy
      width="600"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <visualizar-transacao
        :transacaoSelecionada="transacaoSelecionada"
        @fechar="visualizar = false, transacaoSelecionada = false"
      ></visualizar-transacao>
    </v-dialog>
  </div>
</template>

<script>

import VisualizarTransacao from './VisualizarTransacao.vue'

export default {
  components: { VisualizarTransacao },
  data () {
    return {
      date: new Date().toLocaleDateString(),
      vouchersEmpresa: [],
      paginationCash: {
        rowsPerPage: 10,
        page: 1
      },
      dialogHistoricoCaixa: false,
      dialogVincularCupom: false,
      dialogEditarCupom: false,
      voucherEmpresa: null,
      visualizar: false,
      meiosPagamento: [],
      meioSelecionado: undefined,
      transacoesPagPix: [],
      transacaoSelecionada: undefined,
      menu: false,
      new_date: new Date().toISOString().substr(0, 10)
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    cobrancas () {
      return this.$store.getters.cobrancas
    },
    pagesCash () {
      let count = this.cobrancas.length
      if (this.paginationCash.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.paginationCash.rowsPerPage)
    }
  },
  methods: {
    formatDate (date) {
      this.date = date
        .split('-')
        .reverse()
        .join('/')
    },
    carregarCobrancas () {
      this.$store.dispatch('listarCobrancas', {
        'data_inicio': this.new_date,
        'data_fim': this.new_date,
        'page': this.paginationCash.page - 1
      })
    },
    carregarTransacoesPagPix () {
      const data = {
        method: 'GET',
        data_inicial: this.new_date,
        data_final: this.new_date,
        tipo_transacao: 'imediata'.toLocaleUpperCase()
      }
      this.$store.dispatch('transacoesPagPixBank', data).then(json => {
        this.transacoesPagPix = json
      })
    },
    pegarMeiosDePagamentosSecundarios () {
      this.$store.dispatch('pegarMeiosDePagamentosSecundarios').then(json => {
        this.meiosPagamento = json
        if (json.length > 0) {
          this.meioSelecionado = json[0].forma_pagamento.descricao
        }
      })
    },
    dataAtualFormatada (dataCobranca) {
      let data = new Date(dataCobranca)
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      let hora = data.getHours()
      let min = data.getMinutes()
      return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min
    }
  },
  watch: {
    paginationCash: {
      handler (val, oldval) {
        if (this.meioSelecionado && this.meioSelecionado.toLowerCase() === 'efipix') this.carregarCobrancas()
      },
      deep: true
    },
    meioSelecionado (val) {
      if (val && val.toLowerCase() === 'efipix') {
        this.carregarCobrancas()
      } else if (val && val.toLowerCase() === 'pagpixbank') {
        this.carregarTransacoesPagPix()
      }
    },
    new_date (val) {
      this.menu = false
      if (val) {
        if (this.meioSelecionado.toLowerCase() === 'efipix') this.carregarCobrancas()
        else if (this.meioSelecionado.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
        this.formatDate(val)
      }
    }
  },
  mounted () {
    if (this.frentista) {
      this.pegarMeiosDePagamentosSecundarios()
      if (this.meioSelecionado) {
        if (this.meioSelecionado.toLowerCase() === 'efipix') this.carregarCobrancas()
        else if (this.meioSelecionado.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
      }
    }
  }
}

</script>
